import React from 'react';
import _ from 'lodash';
import Study from './Study/Study';
import ProgressEnum from '../../../../models/learning/ProgressEnum';
import Survey from './Survey/Survey';
import PreAssessment from './PreAssessment/PreAssessment';
import ProjectSubmission from './ProjectSubmission/ProjectSubmission';

const renderModule = (m, learningId, pathId, pathIcon, disabled) => {
  const key = m.studyId || m.surveyId || m.preAssessmentId || m.projectSubmissionId || m.id;
  if (m.studyId)
    return <Study key={key} learningId={learningId} pathId={pathId} module={{ ...m }} icon={pathIcon} disabled={disabled} />;
  if (m.surveyId)
    return <Survey key={key} learningId={learningId} pathId={pathId} module={{ ...m }} icon={pathIcon} disabled={disabled} />;
  if (m.preAssessmentId)
    return (
      <PreAssessment key={key} learningId={learningId} pathId={pathId} module={{ ...m }} icon={pathIcon} disabled={disabled} />
    );
  if (m.projectSubmissionId)
    return (
      <ProjectSubmission
        key={key}
        learningId={learningId}
        pathId={pathId}
        module={{ ...m }}
        icon={pathIcon}
        disabled={disabled}
      />
    );
  return null;
};

const PathModules = ({ learningId, pathId, modules, pathIcon, disabled }) => {
  const isDisabled = (module, moduleIndex) => {
    const isFirstStudy = module.index === 0;
    const isStudyNotStarted = module.progress === ProgressEnum.NotStarted;
    const areAllPreviousModulesCompleted =
      !isFirstStudy && modules.slice(0, moduleIndex).every(m => m.progress === ProgressEnum.Completed);
    return disabled || !(isFirstStudy || !isStudyNotStarted || areAllPreviousModulesCompleted);
  };

  return _.chunk(
    modules.slice().sort((a, b) => a.index - b.index),
    2,
  ).map((c, cIndex) => {
    if (c.length === 2)
      return (
        <div className="clearfix mx4 mb4" key={`row-${cIndex}`}>
          {c.map((m, i) => {
            const moduleIndex = cIndex * 2 + i;
            const moduleDisabled = isDisabled(m, moduleIndex) || m.noActiveSubscriptionLimit === true;
            const wrapperKey = m.studyId || m.surveyId || m.preAssessmentId || m.projectSubmissionId || m.id;
            const rendered = renderModule(m, learningId, pathId, pathIcon, moduleDisabled);
            if (!rendered) return null;
            return (
              <div
                key={wrapperKey}
                className={`sm-col-6 md-col-6 lg-col-6 px3 ${cIndex % 2 !== 0 ? 'col-right' : 'sm-col'}`}
              >
                {rendered}
              </div>
            );
          })}
        </div>
      );
    return (
      <div className="clearfix mx4 mb4" key={`row-${cIndex}`}>
        {c.map((m, i) => {
          const moduleIndex = cIndex * 2 + i;
          const moduleDisabled = isDisabled(m, moduleIndex);
          const wrapperKey = m.studyId || m.surveyId || m.preAssessmentId || m.projectSubmissionId || m.id;
          const rendered = renderModule(m, learningId, pathId, pathIcon, moduleDisabled);
          if (!rendered) return null;
          return (
            <div key={wrapperKey} className="sm-col-6 md-col-6 lg-col-6 mx-auto px3">
              {rendered}
            </div>
          );
        })}
      </div>
    );
  });
};

export default PathModules;
